import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, withCtx as _withCtx, createBlock as _createBlock, createTextVNode as _createTextVNode, withModifiers as _withModifiers, normalizeStyle as _normalizeStyle, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-0c610ccc"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "container" }
const _hoisted_2 = ["src"]
const _hoisted_3 = ["onClick"]
const _hoisted_4 = ["href"]
const _hoisted_5 = { class: "box_language" }
const _hoisted_6 = ["onClick"]
const _hoisted_7 = { class: "box_button" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "iconfont icon-github" }, null, -1 /* HOISTED */))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_MenuOutlined = _resolveComponent("MenuOutlined")!
  const _component_CloseOutlined = _resolveComponent("CloseOutlined")!
  const _component_a_menu_item = _resolveComponent("a-menu-item")!
  const _component_a_menu = _resolveComponent("a-menu")!
  const _component_a_col = _resolveComponent("a-col")!
  const _component_GlobalOutlined = _resolveComponent("GlobalOutlined")!
  const _component_DownOutlined = _resolveComponent("DownOutlined")!
  const _component_a_button = _resolveComponent("a-button")!
  const _component_a_dropdown = _resolveComponent("a-dropdown")!
  const _component_a_row = _resolveComponent("a-row")!

  return (_openBlock(), _createElementBlock("nav", {
    ref: "nav",
    id: "nav",
    class: _normalizeClass(["nav", {active:_ctx.$Store.Public().scroll.y<=80||_ctx.$Store.Public().scroll.dY==='top',nav_bg:_ctx.$Store.Public().scroll.y>80}])
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("img", {
        class: "logo",
        alt: "logo",
        src: $data.file.ImageLogo
      }, null, 8 /* PROPS */, _hoisted_2),
      (_ctx.$Store.Public().isGridMatch('<',_ctx.$Enum.GridEnum.XL))
        ? (_openBlock(), _createElementBlock("div", {
            key: 0,
            class: "button_menu",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$Store.Overseas().updateMenu({isOpen:!_ctx.$Store.Overseas().menu.isOpen})))
          }, [
            _createVNode(_component_MenuOutlined, {
              class: _normalizeClass(!_ctx.$Store.Overseas().menu.isOpen?'active':'')
            }, null, 8 /* PROPS */, ["class"]),
            _createVNode(_component_CloseOutlined, {
              class: _normalizeClass(_ctx.$Store.Overseas().menu.isOpen?'active':'')
            }, null, 8 /* PROPS */, ["class"])
          ]))
        : _createCommentVNode("v-if", true),
      _createElementVNode("div", {
        class: _normalizeClass(["box_menu", _ctx.$Store.Overseas().menu.isOpen?'active':'']),
        style: _normalizeStyle({maxHeight:`${_ctx.$Store.Public().height-60}px`})
      }, [
        _createVNode(_component_a_row, { justify: "end" }, {
          default: _withCtx(() => [
            _createVNode(_component_a_col, {
              xs: 24,
              xl: 14
            }, {
              default: _withCtx(() => [
                _createVNode(_component_a_menu, {
                  mode: _ctx.$Store.Public().isGridMatch('>=',_ctx.$Enum.GridEnum.XL)?'horizontal':'inline',
                  inlineIndent: 35,
                  subMenuCloseDelay: 0.3,
                  selectable: false
                }, {
                  default: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.expand.nav, (item) => {
                      return (_openBlock(), _createBlock(_component_a_menu_item, null, {
                        default: _withCtx(() => [
                          (item.hash)
                            ? (_openBlock(), _createElementBlock("a", {
                                key: 0,
                                onClick: ($event: any) => (_ctx.$router.push({hash:item.hash}))
                              }, _toDisplayString(item.name), 9 /* TEXT, PROPS */, _hoisted_3))
                            : _createCommentVNode("v-if", true),
                          (item.href)
                            ? (_openBlock(), _createElementBlock("a", {
                                key: 1,
                                target: "_blank",
                                href: item.href
                              }, _toDisplayString(item.name), 9 /* TEXT, PROPS */, _hoisted_4))
                            : _createCommentVNode("v-if", true)
                        ]),
                        _: 2 /* DYNAMIC */
                      }, 1024 /* DYNAMIC_SLOTS */))
                    }), 256 /* UNKEYED_FRAGMENT */))
                  ]),
                  _: 1 /* STABLE */
                }, 8 /* PROPS */, ["mode"])
              ]),
              _: 1 /* STABLE */
            }),
            _createVNode(_component_a_col, {
              xs: 24,
              xl: 3
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_5, [
                  _createVNode(_component_a_dropdown, {
                    placement: "bottomRight",
                    overlayClassName: "box_dropdown",
                    getPopupContainer: ()=>_ctx.$refs.nav
                  }, {
                    overlay: _withCtx(() => [
                      _createVNode(_component_a_menu, null, {
                        default: _withCtx(() => [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.$Enum.LanguageDict, (item) => {
                            return (_openBlock(), _createBlock(_component_a_menu_item, null, {
                              default: _withCtx(() => [
                                _createElementVNode("a", {
                                  onClick: ($event: any) => (_ctx.$Store.Overseas().setLanguage(item.value))
                                }, _toDisplayString(item.label), 9 /* TEXT, PROPS */, _hoisted_6)
                              ]),
                              _: 2 /* DYNAMIC */
                            }, 1024 /* DYNAMIC_SLOTS */))
                          }), 256 /* UNKEYED_FRAGMENT */))
                        ]),
                        _: 1 /* STABLE */
                      })
                    ]),
                    default: _withCtx(() => [
                      _createVNode(_component_a_button, {
                        type: "link",
                        onClick: _cache[1] || (_cache[1] = _withModifiers(() => {}, ["prevent"]))
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_GlobalOutlined),
                          _createCommentVNode("{{ $Enum.LanguageDict.find(v => v.value === $Store.Overseas().getLanguage()).label }}"),
                          _createTextVNode(" " + _toDisplayString(_ctx.$Enum.LanguageDict.find(v => v.value === _ctx.$Enum.LanguageEnum.EN).label) + " ", 1 /* TEXT */),
                          _createVNode(_component_DownOutlined)
                        ]),
                        _: 1 /* STABLE */
                      })
                    ]),
                    _: 1 /* STABLE */
                  }, 8 /* PROPS */, ["getPopupContainer"])
                ])
              ]),
              _: 1 /* STABLE */
            }),
            _createVNode(_component_a_col, {
              xs: 24,
              xl: 4
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_7, [
                  _createVNode(_component_a_button, {
                    type: "link",
                    target: "_blank",
                    href: $data.href.github
                  }, {
                    default: _withCtx(() => [
                      _hoisted_8,
                      _createTextVNode(" GitHub ")
                    ]),
                    _: 1 /* STABLE */
                  }, 8 /* PROPS */, ["href"]),
                  _createVNode(_component_a_button, {
                    type: "link",
                    target: "_blank",
                    onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.$router.push({hash:'#footer'})))
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(" Contact us ")
                    ]),
                    _: 1 /* STABLE */
                  })
                ])
              ]),
              _: 1 /* STABLE */
            })
          ]),
          _: 1 /* STABLE */
        })
      ], 6 /* CLASS, STYLE */)
    ])
  ], 2 /* CLASS */))
}